import { Button } from '../components/primitives';
import { ORG_RAIL_SURFACES, PERSONAL_RAIL_SURFACES } from '../components/shell/surfaces';
import type { ShellSurfaceKey } from '../components/shell/useShellSession';
import './Documents.css';
import './SettingsFunctionRoles.css';
import './WorkItems.css';
import { LandingIdeChrome } from './landing/LandingIdeChrome';
import { LandingIdeDocumentsDemo } from './landing/LandingIdeDocumentsDemo';
import { LandingRoleRulesDemo } from './landing/LandingRoleRulesDemo';
import { LandingWebBoardDemo } from './landing/LandingWebBoardDemo';

// The decorative landing rail mirrors the plain web build's left rail —
// the 5 base org surfaces plus the personal surfaces, with NO IDE-only Chat.
// `RAIL_SURFACES` always includes Chat (for icon/badge typing), so compose
// the non-IDE rail explicitly here instead.
const LANDING_RAIL_SURFACES = [...ORG_RAIL_SURFACES, ...PERSONAL_RAIL_SURFACES];

function MockRail({ activeKey }: { activeKey: ShellSurfaceKey }) {
  return (
    <nav className="lp-mock-rail" aria-label="Workspace" aria-hidden="true">
      {LANDING_RAIL_SURFACES.map((s, i) => (
        <div
          key={s.key}
          className="lp-mock-rail-link"
          aria-current={s.key === activeKey ? 'page' : undefined}
        >
          <span className="lp-mock-rail-n">{String(i + 1).padStart(2, '0')}</span>
          <span className="lp-mock-rail-label">{s.label}</span>
        </div>
      ))}
    </nav>
  );
}

export function LandingIdeMock() {
  return (
    <LandingIdeChrome>
      <div className="lp-mock-shell lp-ide-mock">
        <MockRail activeKey="documents" />
        <div className="lp-mock-main">
          <h4 className="lp-mock-page-title">Documents</h4>
          <LandingIdeDocumentsDemo />
        </div>
      </div>
    </LandingIdeChrome>
  );
}

export function LandingWebMock() {
  return (
    <LandingIdeChrome>
      <div className="lp-mock-shell lp-web-shell lp-web-mock">
        <MockRail activeKey="work-items" />
        <div className="lp-mock-main">
          <div className="lp-mock-page-head">
            <h4 className="lp-mock-page-title">Work Items</h4>
            <div className="lp-mock-filter-chips" aria-hidden="true">
              <Button
                type="button"
                variant="ghost"
                size="sm"
                className="lp-mock-filter-chip"
                data-selected="1"
                tabIndex={-1}
                aria-pressed="true"
              >
                My items
              </Button>
              <Button
                type="button"
                variant="ghost"
                size="sm"
                className="lp-mock-filter-chip"
                tabIndex={-1}
                aria-pressed="false"
              >
                Due this week
              </Button>
            </div>
          </div>
          <LandingWebBoardDemo />
        </div>
      </div>
    </LandingIdeChrome>
  );
}

export function LandingRulesMock() {
  return (
    <LandingIdeChrome>
      <div className="lp-mock-shell lp-rules-mock-shell">
        <MockRail activeKey="settings" />
        <div className="lp-mock-main lp-rules-mock-main">
          <LandingRoleRulesDemo />
        </div>
      </div>
    </LandingIdeChrome>
  );
}
